module.exports = __webpack_public_path__ + "img/IMG_0784.8f2350a3.jpg";